export default "__VITE_ASSET__BjGup$05__"